import React from 'react';
import { Leaf, ChefHat, Clock, Truck } from 'lucide-react';
import { restaurantInfo, highlights } from '../data/mock';

const iconMap = {
  Leaf: Leaf,
  ChefHat: ChefHat,
  Clock: Clock,
  Truck: Truck,
};

const AboutSection = () => {
  return (
    <section id="sobre" className="section-padding bg-neutral-950 relative overflow-hidden" aria-labelledby="about-heading">
      {/* Background Pattern */}
      <div className="absolute inset-0 oriental-pattern opacity-30" />
      
      {/* Decorative circles */}
      <div className="absolute top-20 left-10 w-64 h-64 bg-amber-700/5 rounded-full blur-3xl" />
      <div className="absolute bottom-20 right-10 w-96 h-96 bg-amber-600/5 rounded-full blur-3xl" />

      <div className="container mx-auto px-6 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-amber-500 font-medium tracking-widest uppercase text-sm">
            Conheça o Japamix
          </span>
          <h2 id="about-heading" className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-white mt-4 mb-6">
            Sobre o Japamix
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-amber-700 to-amber-500 mx-auto" />
        </div>

        {/* Content Grid */}
        <div className="grid lg:grid-cols-2 gap-16 items-center mb-20">
          {/* Image */}
          <div className="relative">
            <div className="relative img-hover-zoom rounded-lg overflow-hidden shadow-2xl">
              <img
                src="https://customer-assets.emergentagent.com/job_japamix-anapolys/artifacts/yxysotlz_PHOTO-2026-01-20-14-00-27.jpg"
                alt="Combinado japonês premium do Japamix em Anápolis"
                className="w-full h-[400px] lg:h-[500px] object-cover"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
            </div>
            
            {/* Floating badge */}
            <div className="absolute -bottom-6 -right-6 bg-amber-700 text-white p-6 rounded-lg shadow-xl">
              <span className="font-serif text-4xl font-bold">+5</span>
              <p className="text-sm uppercase tracking-wider">Anos de<br/>Experiência</p>
            </div>
            
            {/* Decorative border */}
            <div className="absolute -top-4 -left-4 w-full h-full border-2 border-amber-600/30 rounded-lg -z-10" />
          </div>

          {/* Text Content */}
          <div className="lg:pl-8">
            <h3 className="font-serif text-3xl md:text-4xl text-white mb-6 leading-tight">
              O melhor <span className="text-amber-500">restaurante japonês em Anápolis</span>
            </h3>
            
            <p className="text-white/70 text-lg leading-relaxed mb-8">
              {restaurantInfo.description}
            </p>

            <p className="text-white/70 text-lg leading-relaxed mb-8">
              {restaurantInfo.descriptionExtended}
            </p>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-6 pt-8 border-t border-white/10">
              <div className="text-center">
                <span className="font-serif text-4xl font-bold text-amber-600">50+</span>
                <p className="text-white/60 text-sm mt-1">Pratos no cardápio</p>
              </div>
              <div className="text-center">
                <span className="font-serif text-4xl font-bold text-amber-500">1000+</span>
                <p className="text-white/60 text-sm mt-1">Clientes satisfeitos</p>
              </div>
              <div className="text-center">
                <span className="font-serif text-4xl font-bold text-green-500">4.9</span>
                <p className="text-white/60 text-sm mt-1">Avaliação média</p>
              </div>
            </div>
          </div>
        </div>

        {/* Highlights Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {highlights.map((item, index) => {
            const IconComponent = iconMap[item.icon];
            return (
              <article
                key={index}
                className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl p-6 text-center hover:bg-white/10 transition-all duration-300 hover:-translate-y-1 group"
              >
                <div className="w-16 h-16 mx-auto mb-4 bg-gradient-to-br from-amber-700 to-amber-500 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                  <IconComponent className="text-white" size={28} aria-hidden="true" />
                </div>
                <h4 className="font-semibold text-white text-lg mb-2">{item.title}</h4>
                <p className="text-white/60 text-sm leading-relaxed">{item.description}</p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
